import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const fetchUnreadMessagesCountRequest = () => ({
  type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_REQUEST,
});

export const fetchUnreadMessagesCountFailure = () => ({
  type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_FAILURE,
});

export const fetchUnreadMessagesCountSuccess = (count) => ({
  type: actionTypes.FETCH_UNREAD_MESSAGES_COUNT_SUCCESS,
  count,
});

export const fetchUnreadMessagesCount = () => async (dispatch) => {
  try {
    dispatch(fetchUnreadMessagesCountRequest());
    const count = await api.fetchUnreadMessagesCount();

    dispatch(fetchUnreadMessagesCountSuccess(count));
  } catch (error) {
    dispatch(fetchUnreadMessagesCountFailure(error));
    console.error('FETCH_UNREAD_MESSAGES', error);
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/actions/unread-count.actions.js